export const tokens = {
  colors: {
    background: '#08080d',
    backgroundSecondary: '#0f0f18',
    surface: '#161625',
    surfaceHover: '#1e1e32',
    surfaceBorder: 'rgba(148,163,184,0.08)',
    primary: '#6366f1',
    primaryMuted: 'rgba(99,102,241,0.15)',
    secondary: '#8b5cf6',
    text: '#f1f5f9',
    textMuted: '#94a3b8',
    textDim: '#64748b',
    success: '#34d399',
    danger: '#fb7185',
    info: '#22d3ee',
    violet: '#a78bfa',
    warning: '#fbbf24',
    white: '#ffffff',
  },
  glass: {
    background: '#161625',
    backgroundHover: '#1e1e32',
    border: 'rgba(148,163,184,0.08)',
    borderHover: 'rgba(148,163,184,0.18)',
    blur: '20px',
  },
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', monospace",
  },
  radii: {
    sm: '6px',
    md: '10px',
    lg: '14px',
    xl: '18px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  shadows: {
    card: '0 2px 8px rgba(0,0,0,0.3)',
    elevated: '0 4px 20px rgba(0,0,0,0.4)',
    glow: '0 0 20px rgba(99,102,241,0.08)',
    glowStrong: '0 0 30px rgba(99,102,241,0.15)',
  },
};

export type ThemeTokens = typeof tokens;
